import src from "IMAGE";
export default { src, width: 21000, height: 4469, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAR0lEQVR42hXHsQ2AQAhA0ZvljG5jZ6Kx0t5t6OkghJJtSGAXofjJ+wMRXyK6ReQsP8x8tQHga4+ImNXi7puqHma2l9f+zJw/5AUnAwgqTQ4AAAAASUVORK5CYII="};
